module.exports = __webpack_public_path__ + "img/filter-button.cf6af1f1.svg";